import React, {useEffect} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import {GET_FARM_URL} from "../../api";

const Farm = (props) => {

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#farm_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading farms</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(GET_FARM_URL, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load farms', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        return (data?.name) ?? '—';
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        return data?.farmer ? `${data.farmer.first_name || ''} ${data.farmer.last_name || ''}`.trim() || '—' : '—';
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        return (data?.province?.name ?? data?.nearest_town?.name ?? '—');
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        return data?.area != null ? String(data.area) : '—';
                    },
                    targets: 3
                },
                {
                    render: function(data) {
                        return `<a href="#" class="nav-link view_farm"><i class="fa fa-eye"></i> View farm</a>`;
                    },
                    targets: 4
                }
            ]
        });

        table.on('click', '.view_farm', function(e) {
            e.preventDefault();
            let rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id) {
                props.history.push(`/farm/${rowData.raw.id}`);
            }
            return false;
        });
    }, [props.history, token]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#farm_table')) {
            $('#farm_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Farms</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Farms</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Farms</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="farm_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-15p">Name</th>
                                            <th className="wd-15p">Farmer</th>
                                            <th className="wd-15p">Province / Town</th>
                                            <th className="wd-12p">Area</th>
                                            <th className="wd-12p">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Farm;
